import { render, staticRenderFns } from "./StartFormSignup.vue?vue&type=template&id=a95ecfe6&scoped=true"
import script from "./StartFormSignup.vue?vue&type=script&lang=ts&setup=true"
export * from "./StartFormSignup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StartFormSignup.vue?vue&type=style&index=0&id=a95ecfe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ecfe6",
  null
  
)

export default component.exports